// src/redux/slices/roleSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL ;

// ✅ GET all roles
export const fetchRoles = createAsyncThunk(
  'roles/fetchRoles',
  async (_, { rejectWithValue }) => {

          const SuperAdminId = localStorage.getItem("adminuserId"); // 🔑 get from localStorage

    try {
      const response = await axios.get(`${BASE_URL}/all-roles`, 

{
    params: {
          SuperAdminId, // ✅ filter applied
        },
}

      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch roles');
    }
  }
);

// ✅ POST create new role
export const addRole = createAsyncThunk(
  'roles/addRole',
  async (roleData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/create-roles`, roleData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Error adding role');
    }
  }
);

// ✅ PUT update role
export const updateRole = createAsyncThunk(
  'roles/updateRole',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${BASE_URL}/update-roles/${id}`, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Error updating role');
    }
  }
);

// ✅ DELETE role
export const deleteRole = createAsyncThunk(
  'roles/deleteRole',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${BASE_URL}/delete-roles/${id}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Error deleting role');
    }
  }
);

const roleSlice = createSlice({
  name: 'roles',
  initialState: {
    items: [],
    status: 'idle',
    error: null,
    success: false,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchRoles.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = Array.isArray(action.payload?.roles) ? action.payload.roles : [];
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Error fetching roles';
        state.items = [];
      })

      // ADD
      .addCase(addRole.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(addRole.fulfilled, (state) => {
        state.status = 'succeeded';
        state.success = true;
      })
      .addCase(addRole.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Error adding role';
      })

      // UPDATE
      .addCase(updateRole.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(updateRole.fulfilled, (state) => {
        state.status = 'succeeded';
        state.success = true;
      })
      .addCase(updateRole.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Error updating role';
      })

      // DELETE
      .addCase(deleteRole.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(deleteRole.fulfilled, (state) => {
        state.status = 'succeeded';
        state.success = true;
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Error deleting role';
      });
  },
});

export const { clearError, clearSuccess } = roleSlice.actions;
export default roleSlice.reducer;



